import { Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { BaseWasteForm } from "./BaseWasteForm";
import { WastesKindsMultiSelect } from "../../../useCases/contractors/Extensions/CreateContractor/WastesKindsMultiSelect";

export function BaseWastesForm({
  wasteFieldName,
  additionalFormControls,
  additionalWasteControls,
  isUsedContainerRequired,
  isAddressIdRequired,
  addressId,
  transactionType,
  requireApplicableKpoItems = false,
  fillWasteMass = true,
  includeExtendedSaleWastesData = false,
  showExtendedView = false,
  usedContainerFieldName = null
}) {
  const GetFieldName = (name) => `${wasteFieldName}.${name}`;
  const GetWasteItemFieldName = (idx) => `${wasteFieldName}.wastes[${idx}]`;
  const { watch } = useFormContext();
  const kpoItems = watch("kpoItems");
  const usedContainer = watch(GetFieldName(usedContainerFieldName ?? "usedContainer"));
  const { usedContainerId } = usedContainer || {};
  const wastes = watch(GetFieldName("wastes"));
  return (
    <>
      <Row>{additionalFormControls}</Row>
      <WastesKindsMultiSelect
        name={GetFieldName("wastes")}
        optionSave={(x) => x}
        required={false}
        isUsedContainerRequired={isUsedContainerRequired}
        isAddressIdRequired={isAddressIdRequired}
        resetOnReadonlyChange
        transactionType={transactionType}
        skipFieldsTrack={false}
        addressId={addressId}
        usedContainerId={usedContainerId}
        skipInitLoading
      />

      {fillWasteMass && wastes?.map((waste, index) => (
        <BaseWasteForm
          key={index}
          parentName={GetWasteItemFieldName(index)}
          waste={waste}
          kpoItems={kpoItems}
          requireApplicableKpoItems={requireApplicableKpoItems}
          additionalWasteControls={additionalWasteControls}
          includeExtendedSaleWastesData={includeExtendedSaleWastesData}
          showExtendedView={showExtendedView}/>
      ))}
    </>
  );
}
